import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const CurrencySection = () => (
  <>
    <SectionHeading>Currency</SectionHeading>
    <ListItem marker="(a)" withBottomMargin>{"All references to sums of money will be in U.S. currency."}</ListItem>
  </>
);

export default CurrencySection;
